window.merchantos.sidebar = {
  toggle() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = document.documentElement.scrollTop;

    const body = $('body');
    const pageContainer = $('.page-container');

    // If user clicks menu (hamburger) icon when drawer is already open
    if (window.parseInt(pageContainer.css('margin-left'), 10) !== 0) {
      body
        .addClass('drawer_selfclosing')
        .removeClass('navigable')
        .removeClass('drawer_always_open');
      document.cookie = 'drawer_selfclosing=true; expires=; path=/';
      document.cookie = 'drawer_always_open=; expires=; path=/';
    } else {
      body.addClass('navigable');

      pageContainer.one('click', () => $('body').removeClass('navigable'));
    }
  },

  toggleDrawerAlwaysOpen() {
    const body = $('body');
    const wrapper = $('#wrapper');

    body.toggleClass('drawer_always_open');

    if (body.hasClass('drawer_always_open')) {
      body.removeClass('drawer_selfclosing');
      document.cookie = 'drawer_always_open=true; expires=; path=/';
      document.cookie = 'drawer_selfclosing=; expires=; path=/';
    } else {
      body.addClass('navigable');
      document.cookie = 'drawer_always_open=; expires=; path=/';
      wrapper.one('click', () => body.removeClass('navigable'));
    }
  },
};
